import styles from "./ButtonForm.module.css"

function ButtonForm({ children }) {
    return (
        <button
            type="submit"
            className={styles.buttonForm}
        >
            {children}
        </button>
    )
}

export default ButtonForm;